import { Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { allCarrerasAction } from '../../../sistema/carreras/CarrerasAction';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allEntCarrerasAction,
  deleteEntCarrerasAction,
  setActivoEntCarrerasAction,
} from '../EntCarrerasAction';
import { PARAMS_ENT_CARRERAS } from '../EntCarrerasReducer';

const ListadoEntCarreras = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const carrerasStore = Redux.useSelector((state) => state.carreras);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const entCarrerasStore = Redux.useSelector((state) => state.entCarreras);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    const fetchData = async () => {
      if (carrerasStore.all && carrerasStore.all.length === 0) {
        await allCarrerasAction(dispatch, null);
      }
      const payload = {
        idEntidad: entidadesStore.activo.id,
        ...entCarrerasStore.params,
      };
      dispatch({ type: PARAMS_ENT_CARRERAS, payload });
      if (entCarrerasStore.all && entCarrerasStore.all.length === 0) {
        allEntCarrerasAction(dispatch, payload);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleEditClick = async (id) => {
    const data = entCarrerasStore.all.find((el) => el.id === id);
    await setActivoEntCarrerasAction(dispatch, data);
    setOpenModalForm(true);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteEntCarrerasAction(
      { dispatch, notify },
      entidadesStore.activo.id,
      entCarrerasStore.activo.id,
      entCarrerasStore.params,
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.carrera.name,
      label: CONST.carrera.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value?.nombre ?? '--'}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.modalidad.name,
      label: CONST.modalidad.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <Chip label={value} size="small" color="primary" />;
        },
      },
    },
    {
      name: CONST.totalSecciones.name,
      label: CONST.totalSecciones.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.totalDocentes.name,
      label: CONST.totalDocentes.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.totalMaterias.name,
      label: CONST.totalMaterias.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value.nombre ?? '--'}
                size="small"
                color={value?.id === 1 ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={async () => {
                  const data = entCarrerasStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  await setActivoEntCarrerasAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <LoadingWidget isLoading={entCarrerasStore.loadingAll || loadingDelete} />
      <Grid item md={12}>
        <MUIDataTable
          title={'Listado'}
          data={entCarrerasStore.all}
          columns={columns}
          options={options}
        />
      </Grid>
      {entCarrerasStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            {entCarrerasStore.activo.carrera.nombre}
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoEntCarreras;
